import React from "react";
import { Spinner } from "reactstrap";

const Loader = () => {
  return (
    <Spinner>
      <span></span>
    </Spinner>
  );
};

export default Loader;
